import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware"
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const employerAuditAPI = createApi({
    reducerPath: 'auditAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getEmployerAudit: builder.mutation({
            query: (details) => ({
                url: '/CompanyAudit/GetCompanyAudits',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addEmployerAudit: builder.mutation({
            query: (details) => ({
                url: '/CompanyAudit/AddCompanyAudit',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateEmployerAudit: builder.mutation({
            query: (details) => ({
                url: '/CompanyAudit/UpdateCompanyAudit',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteEmployerAudit: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CompanyAudit/DeleteCompanyAudit/?id=${details}`),
                method: 'DELETE',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        })

    })

})

export const { useGetEmployerAuditMutation, useAddEmployerAuditMutation, useUpdateEmployerAuditMutation, useDeleteEmployerAuditMutation } = employerAuditAPI;

export default employerAuditAPI;